import { render } from "./DeletePostOverlay.vue?vue&type=template&id=7740e6d3"
import script from "./DeletePostOverlay.vue?vue&type=script&lang=js"
export * from "./DeletePostOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__